/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { createContext } from 'preact';
import { Dispatch, StateUpdater, useContext } from 'preact/hooks';

type RichSelectionStartContextValue = {
  isFirst?: boolean;
  setStartData?: Dispatch<
    StateUpdater<{
      hasMedia: boolean;
      hasSecondaryText: boolean;
    }>
  >;
};

const RichSelectionStartContext = createContext<RichSelectionStartContextValue | null>(null);
const useRichSelectionStartContext = () => useContext(RichSelectionStartContext);

export { RichSelectionStartContext, useRichSelectionStartContext };
export type { RichSelectionStartContextValue };
